import React from 'react';

const base = (paths) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    style={{ filter: 'drop-shadow(0 0 8px rgba(230, 57, 80, 0.45))' }}
  >
    {paths}
  </svg>
);

export const IconStream = () =>
  base(
    <>
      <path d="M4 12h2l2-6 4 12 2-6h6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="19" cy="12" r="2" fill="currentColor" opacity="0.5" />
    </>
  );

export const IconServer = () =>
  base(
    <>
      <rect x="4" y="4" width="16" height="5" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
      <rect x="4" y="11" width="16" height="5" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
      <rect x="4" y="18" width="16" height="2" rx="0.8" fill="currentColor" opacity="0.35" />
      <circle cx="7" cy="6.5" r="0.9" fill="currentColor" />
      <circle cx="7" cy="13.5" r="0.9" fill="currentColor" />
    </>
  );

export const IconVideo = () =>
  base(
    <>
      <rect x="3" y="6" width="14" height="12" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <path d="M17 10l4-2v8l-4-2v-4z" fill="currentColor" opacity="0.85" />
    </>
  );

export const IconDevices = () =>
  base(
    <>
      <rect x="2" y="5" width="13" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
      <rect x="14" y="8" width="8" height="11" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <path d="M5 20h7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </>
  );

export const IconNetwork = () =>
  base(
    <>
      <path d="M12 20v-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M5 12a7 7 0 0114 0" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M8 12a4 4 0 018 0" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="12" cy="20" r="1.2" fill="currentColor" />
    </>
  );

export const IconCatalog = () =>
  base(
    <>
      <path d="M4 6h16M4 12h16M4 18h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <rect x="16" y="16" width="4" height="4" rx="0.8" stroke="currentColor" strokeWidth="1.3" />
    </>
  );

export const IconShield = () =>
  base(
    <>
      <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  );

export const IconApps = () =>
  base(
    <>
      <rect x="4" y="4" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.4" />
      <rect x="13" y="4" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.4" />
      <rect x="4" y="13" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.4" />
      <rect x="13" y="13" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.4" />
    </>
  );

export const IconCalendar = () =>
  base(
    <>
      <rect x="4" y="5" width="16" height="15" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <path d="M8 3v4M16 3v4M4 10h16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </>
  );

export const IconUsers = () =>
  base(
    <>
      <circle cx="9" cy="9" r="3" stroke="currentColor" strokeWidth="1.5" />
      <path d="M3 19c0-3 2.7-5 6-5s6 2 6 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="17" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.4" />
      <path d="M14 19c0-2.2 1.5-3.5 4-3.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </>
  );

export const IconPackage = () =>
  base(
    <>
      <path d="M12 3l9 5-9 5-9-5 9-5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M3 8v8l9 5 9-5V8" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M12 13v8" stroke="currentColor" strokeWidth="1.5" />
    </>
  );

export const IconSetup = () =>
  base(
    <>
      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5" />
      <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </>
  );

export const IconReseller = () =>
  base(
    <>
      <path d="M4 18V8l8-4 8 4v10" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M8 14h8M8 11h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </>
  );

export const IconSupport = () =>
  base(
    <>
      <path d="M4 12a8 8 0 0116 0v4H4v-4z" stroke="currentColor" strokeWidth="1.5" />
      <path d="M8 20h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="12" cy="12" r="1.5" fill="currentColor" />
    </>
  );

export const IconCloud = () =>
  base(
    <>
      <path d="M7 18h11a4 4 0 000-8 5 5 0 00-9.8-1.2A3.5 3.5 0 007 18z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </>
  );

export const IconCodec = () =>
  base(
    <>
      <path d="M8 8l-4 4 4 4M16 8l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13 6l-2 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </>
  );

export const IconFaq = () =>
  base(
    <>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
      <path d="M9.5 9a2.5 2.5 0 014.8 1c0 2-2.3 2-2.3 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="12" cy="17" r="0.9" fill="currentColor" />
    </>
  );

export const IconGlobe = () =>
  base(
    <>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
      <path d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18" stroke="currentColor" strokeWidth="1.3" />
    </>
  );

export const IconChart = () =>
  base(
    <>
      <path d="M4 18V6M9 18v-6M14 18V9M20 18v-10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </>
  );

export const SEO_ICON_MAP = {
  stream: IconStream,
  server: IconServer,
  video: IconVideo,
  devices: IconDevices,
  network: IconNetwork,
  catalog: IconCatalog,
  shield: IconShield,
  apps: IconApps,
  calendar: IconCalendar,
  users: IconUsers,
  package: IconPackage,
  setup: IconSetup,
  reseller: IconReseller,
  support: IconSupport,
  cloud: IconCloud,
  codec: IconCodec,
  faq: IconFaq,
  globe: IconGlobe,
  chart: IconChart
};

export const SeoIcon = ({ name }) => {
  const Icon = SEO_ICON_MAP[name] || IconServer;
  return <span className="seo-section-icon-svg">{<Icon />}</span>;
};
